"use client";
import React from "react";
import { Badge } from "@/components/hongkong-setup-v2/ui/badge";
import { Button } from "@/components/hongkong-setup-v2/ui/button";
import Image from "next/image";
import { WA_NUMBERS } from "@/lib/consultation-links";
import { openWhatsAppWithUtm } from "@/lib/whatsapp";


const features = [
  { text: "Backed by insiders" },
  { text: "Backed by insiders" },
  { text: "Trusted by 7‑figure businesses" },
];

export const LayoutWrapperSection = () => {
  return (
    <section className="relative w-full max-w-[1238px] mx-auto bg-[#0f1218] rounded-2xl md:rounded-3xl overflow-hidden backdrop-blur-[58px] backdrop-brightness-[100%] [-webkit-backdrop-filter:blur(58px)_brightness(100%)] py-8 md:py-12 lg:py-[39px] px-4 md:px-6 lg:px-8">
      <div className="text-center mb-[19px]">
         <Badge className="px-3 py-2 bg-[#4ade801a] border-green-400 inline-flex items-center gap-1.5 rounded-[48px] border border-solid">
            <Image
              className="relative flex-[0_0_auto] w-4 h-4"
              alt="Frame"
              src="/hongkong-setup-v2/frame.svg"
              width={16}
              height={16}
            />
            <span className="font-inter font-semibold text-green-400 text-sm md:text-base text-center tracking-[0] leading-[17.6px] whitespace-nowrap">
              Smart Strategy
            </span>
          </Badge>
        </div>
      <div className="flex flex-col w-full max-w-[974px] mx-auto items-center gap-6 md:gap-8 lg:gap-10">
      
        <h2 className="w-full max-w-[974px] [font-family:'SharpGroteskPeTrialSmBold-15',sans-serif]  text-transparent font-[400] text-[26px] sm:text-3xl md:text-[36px] lg:text-[40px] text-center tracking-[0] leading-[34px] md:leading-[47.6px] px-2">
          <span className="bg-gradient-to-r from-[rgba(74,222,128,1)] to-[rgba(255,255,255,1)] bg-clip-text text-transparent">
            Smart entrepreneurs don't play roulette with{" "}
            <span className="hidden md:inline">
              <br />
            </span>
            Stripe. They choose a Hong Kong PSP setup{" "}
            <span className="hidden md:inline">
              <br />
            </span>
            engineered by insiders for guaranteed <br/>reliability.
          </span>
        </h2>
        <div className="flex flex-col items-center w-full gap-4 md:gap-[24px]">
          <div className="flex items-center justify-center w-full">
            <button
              type="button"
              onClick={() => openWhatsAppWithUtm(WA_NUMBERS, "hk-setup")}
              className="
                cursor-pointer h-9 px-[20px] py-2
    relative
    w-full sm:w-auto
    inline-flex items-center justify-center gap-2
     sm:py-6
    rounded-xl
    bg-[#335cff]
    text-white
    font-bold
    overflow-hidden

    transition-all duration-300 ease-out
    hover:scale-[1.03]
    hover:-translate-y-1
    hover:shadow-[0_12px_30px_rgba(51,92,255,0.45)]
    hover:bg-gradient-to-r hover:from-[#476cff] hover:to-[#004eff]
    active:scale-[0.98]
  "
            >
              {/* <div className="absolute top-10 left-1 w-[326px] h-20 rounded-[163px/40px] bg-[#d9d9d9] blur-[27px] hidden sm:block" /> */}
              <div className="absolute left-[3.5px] bottom-[-68px] w-[326px] h-[80px] rounded-[326px] bg-[#D9D9D9] blur-[27px]"></div>
              <span className="relative font-inter font-[300] text-[#ffffff] text-[11px] lg:text-[17px] tracking-[-0.36px] leading-tight sm:leading-7 text-center sm:whitespace-nowrap">
                Escape Stripe/PayPal/Shopify Bans – Unlock a Stable PSP Setup
              </span>
            </button>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-2 lg:gap-7 md:inline-flex md:items-start">
            {features.map((feature, index) => (
              <Badge
                key={index}
                variant="outline"
                className={`h-auto md:h-10 inline-flex items-center gap-2 px-3 md:px-4 lg:py-2 py-0 rounded-xl backdrop-blur-[2px] backdrop-brightness-[100%] [-webkit-backdrop-filter:blur(2px)_brightness(100%)] border-0  ${
                  index > 0 ? "md:ml-[-18px]" : ""
                }`}
              >
                <span className="font-inter font-normal text-green-400 text-sm md:text-base text-center tracking-[0] leading-6 whitespace-nowrap">
                  ✓
                </span>
                <span className="opacity-90 font-inter font-normal text-zinc-50 text-xs md:text-[15px] text-center tracking-[0] leading-6 whitespace-nowrap">
                  {feature.text}
                </span>
              </Badge>
            ))}
          </div>
        </div>
      </div>

      <Image
        className="absolute top-[366px] left-[-100px] w-[891px] h-[366px] hidden lg:block opacity-50"
        alt="Rectangle"
        src="/hongkong-setup-v2/GreenRectangle2.svg"
        width={891}
        height={366}
      />

      <Image
        className="absolute top-[372px] left-[358px] w-[1071px] h-[380px] hidden lg:block opacity-50"
        alt="Rectangle"
        src="/hongkong-setup-v2/GreenRectangle.svg"
        width={1071}
        height={380}
      />
    </section>
  );
};
